import { createFileRoute } from "@tanstack/react-router";
import { AdminLayout } from "@/pages/admin/AdminLayout";
import CaseStudies from "@/pages/admin/CaseStudies";
import { buildSeoHead, publicPageSeo } from "@/data/seo";

export const Route = createFileRoute("/admin/case-studies")({
  head: () =>
    buildSeoHead(
      { ...publicPageSeo.home, key: "admin-case-studies", path: "/admin/case-studies", title: "Cloud Admin Case Studies", description: "Administrationsyta" },
      [],
      { noindex: true },
    ),
  component: () => <AdminLayout><CaseStudies /></AdminLayout>,
});
